import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledImg = styled.img`
  ${props => (props.$margin ? `margin: ${props.$margin};` : null)};
`;

function MImage(props) {
  const { src, width, height, className, margin } = props;
  return (
    <StyledImg
      src={src}
      width={width}
      height={height}
      className={className}
      $margin={margin}
      loading="lazy"
    />
  );
}

MImage.propTypes = {
  src: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  margin: PropTypes.string,
};

export default MImage;
